<template lang="pug">
    v-dialog( persistent max-width="850px" v-model="open" )
        v-toolbar( color="blue darken-4" dark sticky flat )
            v-toolbar-title Crear nuevo centro de costo
            v-spacer
            v-btn( icon dark @click="toggleOpen")
                v-icon close
        v-layout( row wrap )
            v-flex( xs11 )
                v-text-field.mt-4.ml-4(
                    label="Centro de costo"
                    maxlength="100"
                    v-model="inputCostCenter"
                    )
        v-layout( row wrap )
            v-flex( text-xs-right )
                v-btn.ma-3(color="success" dark large @click="submitCreateCostCenter") Crear centro de costo
</template>

<script>
//-
import { mapActions, mapState } from 'vuex'
import { createCostCenter, findByName } from '@/services/api/costCenter'
export default {
    name: 'component-name',
    // props: {},
    data: function(){
        return {
            open: false,
            inputCostCenter: "",
        }
    },
    computed: {
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
    },
    methods: {
        // -- UI Modification
        submitCreateCostCenter: async function() {
            //- Campos
            if(this.inputCostCenter === "" || this.inputCostCenter == null){
                this.showSnackbar( 'info', 'Acción incorrecta', 'Ingrese información')
            }
            // Comprobar que no esté creado anteriormente
            else if(this.inputCostCenter !== null) {
                let costCenterName = await findByName(this.inputCostCenter)
                console.log('resp find name: ', costCenterName)
                if(costCenterName.total > 0){
                    this.showSnackbar( 'warning', 'Acción inválida', 'Nombre ingresado ya se encuentra registrado')
                }
                else {
                    // Crea nuevo centro de costos
                    let response = await createCostCenter({name: this.inputCostCenter})
                    if(response.status == "success"){
                        let snackInfo = this.fillSnack('success', 'Éxito', 'Centro de costo creado con éxito', false, 3000)
                        this.initSnackbar(snackInfo)
                        this.$emit('success')
                        this.toggleOpen()
                    }
                    else{
                        let snackInfo = this.fillSnack('error', 'Error', response, false, 3000)
                        this.initSnackbar(snackInfo)
                    }
                }
            }
        },
        // -- Data fetching
        // -- Data handling and transformations
        // -- Validations and Error handling
        // -- Other functions
        toggleOpen() {
            this.open = !this.open
            this.inputCostCenter = ""
        },
        // -- Vuex mappings
        showSnackbar: function(type, title, message) {
            this.initSnackbar(this.fillSnack(type, title, message))
        },
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
    },
    watch: {
        open(val) {
            if (val == true) {
                //- 
            }
        },
    },
    // components: {},
    // mixins: [],
    // filters: {},
    // -- Lifecycle Methods
    // -- End Lifecycle Methods
}
</script>

<style lang="scss">
    
</style>